import useCustomHook from '@/hooks/useCustomHook';

export default function useHelpButton() {
  const { state, actions } = useCustomHook({
    defaultState: {
      modalOpened: false,
    },
    actions: {
      toggleModalOpened: () => {
        actions.setState({
          modalOpened: !state.modalOpened,
        });
      },
    },
  });

  return { state, actions };
}
